import React from 'react';
import PropTypes from 'prop-types';
import { Panel, Row } from 'react-bootstrap';

import { colours, scenarios } from './../helpers';
import PieChartComponent from './PieChartComponent';
import BuildHealthFeedbackContainer from './../Containers/BuildHealthFeedbackContainer';

const pieSlices = scenarios.getPieSlices(scenarios.SCENARIO_IMPORTANCE, colours.colours);

const BuildHealthDispatcherPieStatsComponent = ({
  style,
  title,
  dashboardLink,
  buildId,
  pieData,
  dispatcherNumber,
  dispatcherId,
  dispatcherType,
  pieDataPercentageRows,
  annotatedItem,
  onShowCommentsClick
}) => {
  return (
    <div>
      <Panel bsStyle={style}>
        <Panel.Heading>
          <Panel.Title>
            <div className="row">
              <div className="col-sm-7">
                {title}
              </div>
              <div>
                <BuildHealthFeedbackContainer
                  buildId={buildId}
                  dispatcherId={dispatcherId}
                  dispatcherType={dispatcherType}
                  annotatedItem={annotatedItem}
                />
              </div>
            </div>
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body sytle={{ 'padding': '0px' }}>
          <div className="row">
            <div className="col-sm-6">
              <PieChartComponent
                height={230}
                slices={pieSlices}
                data={pieData}
              />
            </div>
            <div className="col-sm-6">
              <Row style={{ 'paddingBottom': 2 }}>
                <span style={{ 'fontWeight': 'bold' }, { 'fontSize': 'medium' }}>
                  <br />
                  <a href={dashboardLink}>Dispatcher #{dispatcherNumber} result</a>
                </span>
              </Row>
              {pieDataPercentageRows}
            </div>
          </div>
        </Panel.Body>
        <Panel.Footer>
          <div>
            <a onClick={() => onShowCommentsClick(annotatedItem, dispatcherId)}>
              Show Comments</a>
          </div>
        </Panel.Footer>
      </Panel>
    </div>
  );
};

BuildHealthDispatcherPieStatsComponent.propTypes = {
  style: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  dashboardLink: PropTypes.string.isRequired,
  buildId: PropTypes.string,
  pieData: PropTypes.arrayOf(PropTypes.number).isRequired,
  pieDataPercentage: PropTypes.object.isRequired,
  dispatcherNumber: PropTypes.string.isRequired,
  dispatcherId: PropTypes.number.isRequired,
  dispatcherType: PropTypes.string.isRequired,
  pieDataPercentageRows: PropTypes.array.isRequired,
  annotatedItem: PropTypes.object,
  onShowCommentsClick: PropTypes.func.isRequired
};

export default BuildHealthDispatcherPieStatsComponent;


// WEBPACK FOOTER //
// src/Components/BuildHealthDispatcherPieStatsComponent.jsx